module.exports = __webpack_public_path__ + "img/figure-15.1861fff5.png";